import type React from 'react';

import ContentTitleSkeleton from '@/components/ContentTitleSkeleton';

import MobileOrDesktopRendererSSR from '@cineamo/composables/src/MobileOrDesktopRendererSSR';

import AllShowingDaysSliderSkeleton from './AllShowingDaysSliderSkeleton';

type ShowingListItemSkeletonProps = {
    selectedDate?: string | 'all';
};

const ShowingListItemSkeleton: React.FC<ShowingListItemSkeletonProps> = (props) => {
    return (
        <MobileOrDesktopRendererSSR
            desktopContent={
                <div className="flex flex-col animate-pulse-skeleton">
                    <div className="flex flex-col py-24 space-y-16">
                        <div className="w-full flex flex-col py-0">
                            <div className="flex space-x-24">
                                <div className="w-[120px] h-[180px] bg-[var(--surface-color)] rounded-8 shrink-0" />
                                <div className="flex flex-col w-[480px] shrink-0 h-full">
                                    <ContentTitleSkeleton />
                                    <div className="my-16 flex flex-col space-y-4">
                                        <div className="w-full h-[20px] bg-[var(--surface-color)] rounded-4" />
                                        <div className="w-full h-[20px] bg-[var(--surface-color)] rounded-4" />
                                        <div className="w-full h-[20px] bg-[var(--surface-color)] rounded-4" />
                                    </div>
                                    <div className="grow"></div>
                                    <div className="w-1/2 h-[20px] bg-[var(--surface-color)] rounded-4" />
                                </div>
                                <AllShowingDaysSliderSkeleton selectedDate={props.selectedDate} />
                            </div>
                        </div>
                    </div>
                </div>
            }
            mobileContent={
                <div className="animate-pulse-skeleton">
                    <div className="flex flex-col py-16 space-y-12">
                        <ContentTitleSkeleton />
                        <div className="w-full h-210 bg-[var(--surface-color)] rounded-4" />
                        <div className="w-1/2 h-[20px] bg-[var(--surface-color)] rounded-4" />
                        <AllShowingDaysSliderSkeleton selectedDate={props.selectedDate} />
                    </div>
                </div>
            }
        />
    );
};

export default ShowingListItemSkeleton;
